import * as React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ActividadContext } from "../../Context/ActividadContext";
import { Checkbox, TableSortLabel } from "@mui/material";

const headCells = [
  {
    id: "actividad",
    padding: "normal",
    align: "left",
    label: "Actividad",
    sortable: true,
    sx: {
      minWidth: 400,
    },
  },
  {
    id: "prioridad",
    padding: "checkbox",
    align: "left",
    label: "Importancia",
    sortable: false,
    sx: {
      minWidth: 150,
    },
  },
  {
    id: "contacto",
    padding: "normal",
    align: "left",
    label: "Vinculado a",
    sortable: true,
    sx: {
      minWidth: 250,
    },
  },
  {
    id: "status",
    padding: "checkbox",
    align: "left",
    label: "Status",
    sortable: false,
    sx: {
      minWidth: 150,
    },
  },
  {
    id: "fechaInicio",
    padding: "normal",
    align: "left",
    label: "Recordar el",
    sortable: true,
    sx: {
      minWidth: 240,
    },
  },
  {
    id: "fechaFin",
    padding: "normal",
    align: "left",
    label: "Vence el",
    sortable: true,
    sx: {
      minWidth: 200,
    },
  },
  {
    id: "trato",
    padding: "normal",
    align: "left",
    label: "Trato",
    sortable: true,
    sx: {
      minWidth: 250,
    },
  },
  {
    id: "accion",
    padding: "normal",
    align: "left",
    label: "Acción",
    sortable: false,
    sx: {
      minWidth: 220,
    },
  },
  {
    id: "notas",
    padding: "normal",
    align: "left",
    label: "Notas",
    sortable: true,
    sx: {
      minWidth: 400,
    },
  },
  {
    id: "resultado",
    padding: "normal",
    align: "left",
    label: "Resultado",
    sortable: true,
    sx: {
      minWidth: 200,
    },
  },
  {
    id: "usuario",
    padding: "normal",
    align: "left",
    label: "Usuario asignado",
    sortable: true,
    sx: {
      minWidth: 250,
    },
  },
  {
    id: "ubicacion",
    padding: "checkbox",
    align: "left",
    label: "Ubicacion",
    sortable: false,
    sx: {
      minWidth: 180,
    },
  },
  {
    id: "descripcionUbicacion",
    padding: "checkbox",
    align: "center",
    label: "Descripción ubicación",
    sortable: false,
    sx: {
      minWidth: 200,
    },
  },
  {
    id: "fechaRegistro",
    padding: "normal",
    align: "left",
    label: "Fecha registro",
    sortable: true,
    sx: {
      minWidth: 150,
    },
  },
];

export default function ActividadesTableHead({
  handleSort,
  order,
  orderBy,
  handleCheckAll,
}) {
  const { itemsSelected, indeterminated } = React.useContext(ActividadContext);

  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          sx={{
            position: { xs: "relative", sm: "sticky" },
            left: 0,
            zIndex: 3,
          }}
        >
          <Checkbox
            indeterminate={indeterminated}
            checked={itemsSelected.length > 0 && !indeterminated}
            onChange={(e) => handleCheckAll(e.target.checked)}
          />
        </TableCell>
        <TableCell />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sx={headCell.sx}
            sortDirection={orderBy === headCell.id ? order : false}
            padding={headCell.padding}
            align={headCell.align}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={() => handleSort(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
